module.exports = __webpack_public_path__ + "static/media/user-roles-icon.c883c321.svg";